export default "__VITE_ASSET__cc721fc6__"